module.exports = __webpack_public_path__ + "static/media/WXreminding.1066fa78.svg";